var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowOutwardIcon = function SvgArrowOutwardIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79126 7.20874C6.79126 7.75874 7.24126 8.20874 7.79126 8.20874H15.3813L6.50126 17.0887C6.11126 17.4787 6.11126 18.1087 6.50126 18.4987C6.89126 18.8887 7.52126 18.8887 7.91126 18.4987L16.7913 9.61874V17.2087C16.7913 17.7587 17.2413 18.2087 17.7913 18.2087C18.3413 18.2087 18.7913 17.7587 18.7913 17.2087V7.20874C18.7913 6.65874 18.3413 6.20874 17.7913 6.20874H7.79126C7.24126 6.20874 6.79126 6.65874 6.79126 7.20874Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowOutwardIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "arrow-outward-icon.61e0f7354afc385050abeb5f12b041d2.svg";